import { render, staticRenderFns } from "./accountBalancesReport.vue?vue&type=template&id=215630b4&"
import script from "./accountBalancesReport.vue?vue&type=script&lang=js&"
export * from "./accountBalancesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports